import type {JSX} from 'react'

import {Link} from 'react-router'

import {useAppSelector} from '../hooks'

/**
 * A button to lead into admin section.
 */
export default function AdminButton(): JSX.Element | null {
  const isAdmin = useAppSelector<boolean>(state =>
    state.user.isAuthenticated && (state.user.claims?.isAdmin ?? false))
  if (!isAdmin) {
    return null
  }

  return (
    <Link to='/admin' className='btn btn-primary'>Admin</Link>
  )
}
